import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DodoError } from "app/shared/models/error.model";

@Component({
    selector: "dodo-error-dialog",
    templateUrl: "./error-dialog.component.html",
    styleUrls: ["./error-dialog.component.scss"],
    standalone: false
})
export class ErrorDialogComponent implements OnInit {
	public title: string;
	public errorMessageLine1: string;
	public errorMessageLine2: string;

	constructor(
		public dialogRef: MatDialogRef<ErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DodoError
	) {
		this.title = data.errorCode;
		this.errorMessageLine1 = data.title;
		this.errorMessageLine2 = data.msg;
	}

	ngOnInit() {}

	public continueClicked() {
		console.log("continue button clicked ...");
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}
}
